import React from "react"
import compute from "../../../../utils/compute"
import { useTranslation } from "react-i18next"

interface IRequestingProps extends IRequestingOwnProps {}

interface IRequestingOwnProps {
  veTTTtRatio: number
  unstakeAmount: number
  handleCloseRequesting: () => void
  handleUnstake: () => void
}

const Requesting: React.FC<IRequestingProps> = (props: IRequestingProps) => {
  const { t } = useTranslation()
  const { veTTTtRatio, unstakeAmount, handleCloseRequesting, handleUnstake } = props

  return (
    <div>
      <div className="mt-[16px] text-[24px] leading-[32px] dark:text-white text-black font-mont font-semibold text-center">
        {t("staking.unstake.unstake")}
      </div>
      <div className="px-[8px] mt-[8px] text-[14px] leading-[20px] text-secondary dark:text-neutrals-500">
        {t("staking.unstake.desc2")}
      </div>
      <div className="px-[8px] text-[14px] leading-[20px] text-secondary dark:text-neutrals-500">
        {t("staking.unstake.desc3")}
      </div>
      <div className="flex flex-col space-y-[8px] px-[18px] py-[16px] mt-[16px] bg-variant-50 dark:bg-neutrals-800 rounded-[10px]">
        <div className="flex flex-row justify-between">
          <div className="text-[12px] leading-[20px] dark:text-white text-black">
            {t("staking.unstake.amount")}
          </div>
          <div className="text-[12px] leading-[20px] dark:text-white text-black">
            {compute.roundNumberShort(unstakeAmount)} veTT
          </div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-[12px] leading-[20px] dark:text-white text-black">
            {t("staking.stake.youWillGet")}
          </div>
          <div className="text-[12px] leading-[20px] dark:text-white text-black">
            {compute.roundNumberShort(unstakeAmount * veTTTtRatio)} TT
          </div>
        </div>
      </div>
      <div className="absolute w-full left-0 bottom-[16px] px-[16px] flex flex-row space-x-[16px]">
        <button onClick={() => handleCloseRequesting()} className="btn btn-link h-[48px] flex-1">
          {t("staking.stake.cancel")}
        </button>
        <button onClick={() => handleUnstake()} className="btn btn-secondary h-[48px] flex-1">
          {t("staking.unstake.unstake")}
        </button>
      </div>
    </div>
  )
}

export default Requesting
